import React from 'react';

import './index.scss';

// eslint-disable-next-line react/prop-types
export default function SubtitleRegular({ children }) {
  return (
    <div className="subtitle-regular">{ children }</div>
  );
}
